const completeWithZero = (number, size) => {
    let _str = `${number}`;
    while (_str.length < size){
        _str = '0' + _str;
    }
    return _str;

}

export default completeWithZero;